import React, { useContext } from 'react';
import DownloadModalWithButton from './DownloadModalWithButton';
import { getReport } from '../../shared/services/downloadReportService';
import { LocalFilesService } from '@shared/services/localFilesService';
import { showErrorToast } from '@shared/services/toastService';
import { PageLoadingContext } from '../../loader/contexts/PageLoadingContext';
import VIEW_SELECT_OPTIONS from '../../strengthsAndChallenges/constants/viewSelectOptions';
import { DATA_DOWNLOAD_TYPES } from '@shared/constants/DataDownloadTypes';

const REPORT_CONFIG = {
  [DATA_DOWNLOAD_TYPES.strengthsAndChallenges]: {
    fileName: 'StrengthsAndChallengesData.zip',
    buildBody: ({ selectedReports, filters }) => ({
      selectedReports,
      ohts: filters.ohts,
      orgId: filters.orgId,
      deltaInstances: selectedReports.includes(VIEW_SELECT_OPTIONS.DELTA.value)
        ? filters.deltaInstances.map(d => d.value)
        : null
    })
  },
  [DATA_DOWNLOAD_TYPES.surveyResults]: {
    fileName: 'SurveyResultsData.zip',
    buildBody: ({ selectedReports }) => ({
      selectedReportFormats: selectedReports
    })
  },
  [DATA_DOWNLOAD_TYPES.aggregatePerformanceReport]: {
    fileName: 'AggregatePerformanceReport.zip',
    buildBody: ({ selectedReports }) => ({
      selectedReportFormats: selectedReports
    })
  }
};

/**
 * @typedef {object} DownloadModalButtonWithHandlerProps
 * @property {Array<*>} reports
 * @property {string} dataDownloadType
 * @property {Array<*>} [reportFormatOptions]
 * @property {Object} [downloadFilters]
 * @property {string} [downloadText]
 */

/**
 * @param {DownloadModalButtonWithHandlerProps} props
 */
const DownloadModalButtonWithHandler = props => {
  const { reports, dataDownloadType, reportFormatOptions, downloadText, downloadFilters } = props;

  const { executeWithLoadingIndicator } = useContext(PageLoadingContext);

  const downloadReports = async (selectedReports, reportFormat) =>
    await executeWithLoadingIndicator(async () => {
      try {
        const config = REPORT_CONFIG[dataDownloadType];
        const response = await getReport(
          config.buildBody({ selectedReports, filters: downloadFilters }),
          dataDownloadType,
          reportFormat
        );
        LocalFilesService.saveBlobToFile(config.fileName, response.data);
      } catch (e) {
        showErrorToast('Error downloading report');
      }
    });

  return (
    <DownloadModalWithButton
      reports={reports}
      downloadReports={downloadReports}
      reportFormatOptions={reportFormatOptions}
      downloadText={downloadText}
    />
  );
};

export default DownloadModalButtonWithHandler;
